export default{
    async getQuestionList(){
        return await this.$axios.$get(
            this.$api.user.question.getList
        )
    },
    async submitQuestion({}, question){
        let result = null;
		let formData = new FormData;
		for (let key in question) {
			if (key == 'files') {
				for( let i = 0; i < question.files.length; i++) {
					let file = question.files[i];
					formData.append('files[]', file);
				}
			} else {
        		formData.append(key, question[key])
			}
		}
        await this.$axios.$post(
            this.$api.user.question.submit,
            formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
        .then(response => {
            result = 200;
        })
        .catch(error => {
        })
        return result;
    },
}